const DrawerIds = {
    BALANCE_ACCOUNTS: 'balanceAccountsDrawer',
    CALCULATION_DETAILS: 'calculationDetailsDrawer',
    DOCUMENT_DETAILS: 'documentDetailsDrawer',
    CLIENT_DETAILS: 'clientDetailsDrawer',
    LEGISLATION_ARTICLE: 'legislationArticleDrawer'
};
export default DrawerIds;
